type Listener = () => void;

const listeners = new Set<Listener>();

export const KeyHuntSignals = {
  subscribe( listener: Listener ): () => void
  {
    listeners.add( listener );
    return () => { listeners.delete( listener ); };
  },

  serverProgressMayHaveChanged(): void
  {
    for ( const listener of [ ...listeners ] )
    {
      try { listener(); } catch ( e ) { console.warn( "[KeyHuntSignals] listener failed", e ); }
    }
  },
};
